import type { BusinessActivity, BusinessProfile } from './types';

export const BUSINESS_ACTIVITY_META: Record<BusinessActivity, { label: string; blurb: string; mark: string }> = {
  trading: { label: 'Trading', blurb: 'Purchases, sales, stock and margins.', mark: '↔' },
  manufacturing: { label: 'Manufacturing', blurb: 'BOMs, production, job work and material flow.', mark: '⚙' },
  retail: { label: 'Retail', blurb: 'Fast-moving sales with simple stock handling.', mark: '▦' },
  services: { label: 'Services', blurb: 'Invoices, projects and professional services.', mark: '✦' },
};
export const BUSINESS_ACTIVITIES: BusinessActivity[] = ['trading', 'manufacturing', 'retail', 'services'];
export function deriveBusinessProfile(activities: BusinessActivity[]): BusinessProfile {
  if (activities.length === 1) return ({ trading: 'trader', manufacturing: 'manufacturer', retail: 'retailer', services: 'services' } as Record<BusinessActivity, BusinessProfile>)[activities[0]!];
  return 'custom';
}
export function activitySummary(activities: BusinessActivity[]): string {
  return activities.map((activity) => BUSINESS_ACTIVITY_META[activity].label).join(' + ');
}
